import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage from '../modules/languageModule'
import { openUrl } from 'Utility/globalMethods'

export const GoToWcfSsoModal = ({ promoUrl }) => (
  <Toggle>
    <MerchantModal
      topBarTitle=' '
      title={formattedMessage.attention}
      primaryAction={() => promoUrl && openUrl(`${promoUrl}`)}
      primaryButtonLabel={formattedMessage.go}
      description={formattedMessage.goToWcfDescriptionModal}
    />
  </Toggle>
)

GoToWcfSsoModal.propTypes = {
  promoUrl: PropTypes.string
}

GoToWcfSsoModal.defaultProps = {
  promoUrl: ''
}

const mapStateToProps = state => ({
  promoUrl: state.MobileSso.wcfPromoUrl
})

export default connect(mapStateToProps)(GoToWcfSsoModal)
